module.exports = __webpack_public_path__ + "static/media/ai-icon.8fb097ab.svg";